import { createSlice } from "@reduxjs/toolkit";

export const root = createSlice({
  name: "root",
  initialState: {
    unreadCount: 0,
    userInfo: {
      name: "",
      email: "",
    },
    permissions: {},
  },
  reducers: {
    setUnreadCount: (state, { payload }) => {
      state.unreadCount = payload;
    },
    setUserInfo: (state, { payload }) => {
      state.userInfo = payload;
    },
    setPermissions: (state, { payload }) => {
      state.permissions = payload;
    },
  },
});

export const { setUnreadCount, setUserInfo, setPermissions } = root?.actions;

export const getUnreadCount = (state) => state.unreadCount;
export const getUserInfo = (state) => state.userInfo;
export const getPermissions = (state) => state.permissions;

export default root?.reducer;
